import React from 'react';
import {
  StyledAuthButton,
  StyledAuthButtonWrapper,
} from '@/components/ui/AuthFormButton/AuthFormButton.styled.ts';

type Props = {
  label: string;
  onClick?: () => void | undefined;
  isLoading: boolean;
};

const AuthFormButton: React.FunctionComponent<Props> = ({ label, onClick, isLoading }) => {
  return (
    <StyledAuthButtonWrapper>
      <StyledAuthButton
        $isLoading={isLoading}
        type={!onClick ? 'submit' : 'button'}
        onClick={onClick}
      >
        {isLoading ? 'Signing In...' : label}
      </StyledAuthButton>
    </StyledAuthButtonWrapper>
  );
};

export default AuthFormButton;
